export const IMAGE_STYLES = {
  none: 'None',
  icon: 'Icon',
  photo: 'Photo',
  '2d': '2D Illustration',
  logo: 'Logo',
  '3d': '3D',
} as any;

export const ImageStyles = Object.keys(IMAGE_STYLES).map((key) => ({
  value: key,
  label: IMAGE_STYLES[key] || '',
}));

const getStylesDescription = (styles: Record<string, string>) => {
  const colors = {} as Record<string, string>;
  Object.keys(styles).forEach((name) => {
    if (name.includes('-color-')) {
      colors[name.replace('--color-', '')] = styles[name];
    }
  });

  return Object.values(colors).join(', ');
};

export const DescriptionsByStyle = {
  [IMAGE_STYLES.none]: (description: string) => `
    ${description}
  `,
  [IMAGE_STYLES.icon]: (description: string, currentStyleRules: Record<string, string>) =>
    `Suggest ideas for an icon that represents: ${description};
    
    The design should follow these patterns:
     - Has to be simple, using the following color scheme: ${getStylesDescription(
       currentStyleRules,
     )}.
     - Has to be minimalist and flat style, using simple, bold lines and shapes.`,
  [IMAGE_STYLES.photo]: (description: string, currentStyleRules: Record<string, string>) =>
    `Suggest ideas for a photo that represents: ${description};
    
    The design should use the following color scheme: ${getStylesDescription(currentStyleRules)}.`,
  [IMAGE_STYLES.logo]: (description: string, currentStyleRules: Record<string, string>) =>
    `Suggest ideas for a logo that represents: ${description};
    
    The design should follow these patterns:
     - Has to be simple.
     - Has to be minimalist and flat style, using simple, bold lines and shapes.
     - Has to be monochromatic, and should use the following color scheme: ${getStylesDescription(
       currentStyleRules,
     )}.`,
  [IMAGE_STYLES['2d']]: (description: string) =>
    `Suggest ideas for a 2d image with the current description: ${description};
    The design pattern should be characterized by:
    
    1. **Flat Design**: The illustrations are two-dimensional without intricate shading or gradients, which is typical of flat design for a clean and modern look.

    2. **Vibrant Colors**: Bright and bold colors are used throughout, adding a lively and engaging touch to each element.

    3. **Simple Geometric Shapes**: Circular and rectangular shapes create a sense of simplicity and organization.

    4. **Illustrated Characters**: Diverse, cartoon-style characters add a personal and approachable aspect to the design.

    5. **Iconography**: The use of icons, such as graphs, globes, and communication tools, suggests various themes like communication, data, and networking.

    6. **Minimalist Backgrounds**: Subtle, muted backgrounds allow the colorful elements and characters to stand out.

    Overall, the pattern creates a playful and professional aesthetic suitable for contemporary digital content.`,
  [IMAGE_STYLES['3d']]: (description: string) =>
    `Suggest ideas for a 3d image with the current description: ${description};
    The design pattern should be characterized by:
    
    1. **Flat Design**: The illustrations are two-dimensional without intricate shading or gradients, which is typical of flat design for a clean and modern look.

    2. **Vibrant Colors**: Bright and bold colors are used throughout, adding a lively and engaging touch to each element.

    3. **Simple Geometric Shapes**: Circular and rectangular shapes create a sense of simplicity and organization.

    4. **Illustrated Characters**: Diverse, cartoon-style characters add a personal and approachable aspect to the design.

    5. **Iconography**: The use of icons, such as graphs, globes, and communication tools, suggests various themes like communication, data, and networking.

    6. **Minimalist Backgrounds**: Subtle, muted backgrounds allow the colorful elements and characters to stand out.

    Overall, the pattern creates a playful and professional aesthetic suitable for contemporary digital content.`,
};
